import * as Sentry from '@sentry/browser';
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { passesDemoGate } from './app/core/demo/demo-gate';
import { environment } from './environments/environment';

// Errors go to self-hosted GlitchTip. GlitchTip implements the Sentry ingest
// API deliberately and ships no SDK of its own, so the client is
// @sentry/browser and only the DSN decides the destination — nothing reaches
// sentry.io. An empty DSN disables the SDK, so demo builds stay silent.
if (environment.glitchtipDsn) {
  Sentry.init({
    dsn: environment.glitchtipDsn,
    environment: environment.environmentName,
    release: environment.glitchtipRelease,
    // GlitchTip ingests no transactions, so tracing would only cost bandwidth.
    // NOTE an empty array still keeps @sentry/browser's DEFAULT integrations
    // (they are concatenated, not replaced) — globalHandlers stays active.
    integrations: [],
    tracesSampleRate: 0,
  });
}

console.log('[startup] mapsKey:', environment.mapsKey);

passesDemoGate()
  .then((allowed) => {
    if (!allowed) {
      return;
    }
    return bootstrapApplication(App, appConfig).then(() => undefined);
  })
  .catch((err) => console.error(err));
